import { Moment } from "moment";
import {
  IDisabledSlot,
  IPrioritySchedulerColumnData,
} from "@miplatform/components";
import { IAttempt, IUserListItemResponse } from "@miplatform/types";
import {
  getDate,
  getWorkingDays,
  isSameDay,
  toFormattedDate,
} from "@miplatform/utils";
import { NHC_ASSIGNMENT_BOARD_DAY_COUNT } from "./NHCPriorityScheduler/useAssignmentStaging";

const resolveOverlappingLogs = (slots: IDisabledSlot[]): IDisabledSlot[] => {
  if (slots.length === 0) return [];

  const sortedSlots = [...slots].sort(
    (a, b) => a.start.valueOf() - b.start.valueOf()
  );

  const processedSlots: IDisabledSlot[] = [sortedSlots[0]];

  for (let i = 1; i < sortedSlots.length; i++) {
    const current = sortedSlots[i];
    const previous = processedSlots[processedSlots.length - 1];

    if (current.start.isBefore(previous.end)) {
      if (current.end.isAfter(previous.end)) {
        current.start = previous.end.clone();
        processedSlots.push(current);
      }
    } else {
      processedSlots.push(current);
    }
  }

  return processedSlots;
};

export const buildDisabledSlots = ({
  user,
  date,
}: {
  user: IUserListItemResponse;
  date: Moment;
}): IDisabledSlot[] =>
  resolveOverlappingLogs(
    user.availabilityLog
      ?.filter(({ from }) => isSameDay(from, date))
      .map((log) => ({
        id: log.id,
        start: getDate(log.from),
        end: getDate(log.to),
        note: log.note,
      })) || []
  );

export const buildUserColumns = ({
  users,
  events,
  date,
}: {
  users: IUserListItemResponse[];
  events: IAttempt[];
  date: Moment;
}): IPrioritySchedulerColumnData[] => {
  const columns = users.map((user) => ({
    id: `${user.id}-column`,
    user,
    events: events.filter((event) => event.assignedUserId === user.id),
    disabledSlots: buildDisabledSlots({ user, date }),
    dateView: false,
  }));

  return columns;
};

export const buildDateColumns = ({
  date,
  events,
  numberOfDays = NHC_ASSIGNMENT_BOARD_DAY_COUNT,
  user,
}: {
  date: Moment;
  events: IAttempt[];
  numberOfDays?: number;
  user?: IUserListItemResponse;
}): IPrioritySchedulerColumnData[] =>
  getWorkingDays(date, numberOfDays).map((date) => ({
    id: `${toFormattedDate(date)}-column`,
    date,
    events: events.filter((event) => isSameDay(event.scheduledStartDate, date)),
    disabledSlots: user ? buildDisabledSlots({ user, date }) : [],
    // TODO: ABK - this flag should be based on the view type
    dateView: true,
  }));
